import { type FC, type ReactNode, useMemo, useState, useEffect } from 'react';
import { EmergencyContext } from './EmergencyContext';
import { useCheckEmergency } from '../api';
import { useCurrentNetwork } from 'hooks';

interface AuthContextProviderProps {
  children: ReactNode;
}

const EmergencyProvider: FC<AuthContextProviderProps> = ({ children }: AuthContextProviderProps) => {
  const [isEmergency, setEmergency] = useState(false);
  const network = useCurrentNetwork();
  const { data: emergency } = useCheckEmergency({ network });

  useEffect(() => {
    setEmergency(emergency?.status === 'enabled');
  }, [emergency]);

  const contextValue = useMemo(
    () => ({
      isEmergency,
      setEmergency,
    }),
    [isEmergency, setEmergency]
  );

  return <EmergencyContext.Provider value={contextValue}>{children}</EmergencyContext.Provider>;
};

export default EmergencyProvider;
